/* eslint-disable react/no-unknown-property */
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import useGa from 'hooks/ga/useGa'
import {
  Box,
  Button,
  Center,
  FormControl,
  FormHelperText,
  Input,
  InputGroup,
  FormErrorMessage,
  InputLeftAddon,
  Link,
  Select,
  Text,
  VStack,
  InputRightElement,
  Image,
  useDisclosure,
  Spinner,
  Flex,
  Heading,
} from '@chakra-ui/react'
import InputMask from 'react-input-mask'
import { useNavigate } from 'react-router-dom'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

import FormInput from 'components/FormInput/formInput'
import { isSuccessStatus } from 'utils/functions/validations'
import { truncateString } from 'utils/functions/formatString'
import PhoneNumber from 'components/InputPhone/inputPhone'
import { useFormContext } from 'providers/FormProvider'
import { useSubscriberContext } from 'providers/SubscriberProvider'
import { postValidateAdministrator } from 'services/api'
import { IFetchedfindInOb2Sib, IReturnSendEmailRecoveryPasswordError } from 'services/IApi.d'
import IBalert from 'components/common/IBalert/IBalert'
import { useAuthContext } from 'providers/AuthProvider'
import { setToken } from 'utils/authentication'
import useIdentityValidationModule from 'hooks/useIdentityValidationModule'
import LoadingScreen from 'components/common/LoadingScreen/LoadingScreen'
import { ICountries } from 'providers/ISubscriberProvider.d'
import { returnSendEmailRecoveryPasswordErrorType } from 'services/returnApiType'
import {
  CODAREA_ARGENTINA,
  COUNTRY_ARGENTINA,
  cuilDigitsLength,
  documentCuilType,
  documentForeignType,
  documentTypes,
  handleClaveValidationData,
  handleCuilValidationData,
  handleDocumentForeignChangeData,
  handleEmailChangeData,
  handleEmailValidationData,
  handleFieldValidationData,
  handleNumberFieldChangeData,
  handleTextFieldsChangeData,
  isEmailSentError,
  isSendlError,
  maxLengthcodAreaData,
  maxLengthNumberData,
  number14,
  subtitleData,
  titleData,
} from './registerSubscriptionData'

import EyeSVG from 'assets/images/eye.svg'
import EyeOffSVG from 'assets/images/eye-off.svg'

import { IRegisterSuscriptionProps } from './registerSubscription.d'
import { STATUS_409 } from 'services/apiData'

const RegisterSuscription: React.FC<IRegisterSuscriptionProps> = ({
  isRecoveryUser,
  isValidateIdentity,
  isNewAccount,
  shouldValidateCollaborator,
  paramsMvi,
}) => {

  const { setSubscriberData, countries, validateInSIB, sendEmailRecoveryPassword, sendValidationEmail } = useSubscriberContext()
  const [showField, setShowField] = useState<boolean>(false)
  const [showFieldIcon, setShowFieldIcon] = useState<boolean>(false)
  const { signinRedirect } = useAuthContext()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [errorCount, setErrorCount] = useState<number>(0)
  const [loadingValidationCollaborator, setLoadingValidationCollaborator] = useState<boolean>(false)
  const { sendDataLayer } = useGa()
  const role = localStorage.getItem('role')

  const { redirectMvi } = useIdentityValidationModule()

  const { collaboratorId } = useSubscriberContext()

  const [documentDisplayName, setDocumentDisplayName] = useState(documentForeignType)
  const { fields, setFields, handleFieldChange, errors, setErrors, handleFieldError } = useFormContext()

  const showtextifArg: string = fields.areaCodePhone === CODAREA_ARGENTINA ? 'Ingresá el código de área sin el 0 y el número sin el 15' : ''

  const countryPhoneCodeLength: number = fields.countryPhoneCode?.length
  const countryCodAreaLength: number = fields.codArea?.length
  const phoneLength: number = fields.phone?.length

  const navigate = useNavigate()

  const dataSubscription: IRegisterSuscriptionProps = useMemo(() => {
    return {
      isRecoveryUser,
      isValidateIdentity,
      isNewAccount,
      shouldValidateCollaborator,
      paramsMvi,
    }
  }, [isRecoveryUser, isValidateIdentity, isNewAccount, shouldValidateCollaborator, paramsMvi])

  const maxLengthcodArea = useMemo(
    (): number => maxLengthcodAreaData(phoneLength, countryPhoneCodeLength, countryCodAreaLength),
    [phoneLength, countryPhoneCodeLength, countryCodAreaLength],
  )

  const maxLengthNumber = useMemo(
    (): number => maxLengthNumberData(countryPhoneCodeLength, countryCodAreaLength),
    [countryPhoneCodeLength, countryCodAreaLength],
  )

  const title = useMemo((): string => titleData(dataSubscription), [dataSubscription])

  const subtitle = useMemo((): string => subtitleData(dataSubscription), [dataSubscription])

  const maxCharacterPhone = useMemo(
    (): number => countryPhoneCodeLength + countryCodAreaLength + phoneLength,
    [countryPhoneCodeLength + countryCodAreaLength + phoneLength],
  )

  const navigateTo = () => {
    if (shouldValidateCollaborator && role === '2') {
      return redirectMvi(paramsMvi)
    }
    const pageBefore = isRecoveryUser && !isNewAccount ? 'recovery' : 'main'
    return navigate('/suscripcion/correo', { state: { pageBefore } })
  }

  const handleTextFieldsChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleTextFieldsChangeData(event, handleFieldChange)
    },
    [handleFieldChange],
  )

  const handleNumberFieldChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleNumberFieldChangeData(event, handleFieldChange)
    },
    [handleFieldChange],
  )

  // FIXME: no se usa por el momento - llegado el caso, se necesita quitar de aqui
  /*  const validateForm = () => {
    const { document, documentForeign } = fields
    const hasErrors: unknown = errors && Object.values(errors).find((error: any) => error.isInvalid)
    const inputFields = Object.entries(fields).filter(field => !field.includes('document') && !field.includes('documentForeign'))
    const isValidDocumentField = document?.length === cuilDigitsLength || documentForeign?.length > 0
    const validInputs = inputFields
      .map((field: any): boolean => {
        let validForm = true
        if (field[1].length === 0) {
          validForm = false
        }
        return validForm
      })
      .every(valid => valid)
    return validInputs && isValidDocumentField && !hasErrors
  } */

  const handleEmailValidation = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleEmailValidationData(event, handleFieldError)
    },
    [handleFieldError],
  )

  const handleEmailChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleEmailChangeData(event, handleFieldChange, handleFieldError)
    },
    [handleFieldChange, handleFieldError],
  )

  const handleCuilValidation = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleCuilValidationData(event, handleFieldError)
    },
    [handleFieldError],
  )

  const handleResetValidation = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    // Solo el cuil se utiliza por el momento - podria hardcodearse
    const { name } = event.target
    setErrors(err => ({
      ...err,
      [name]: {
        isInvalid: false,
      },
    }))
  }, [])

  const handleDocumentDisplayName = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      setFields(prevState => ({
        ...prevState,
        documentType: event.target.value,
        document: '',
        documentForeign: '',
      }))
      if (event) {
        const document = event.target.value
        setDocumentDisplayName(document)
      }
    },
    [document],
  )

  const handleSubscribed = async (): Promise<boolean> => {
    try {
      const { lastName, document, documentForeign, documentType, nacionality, name, areaCode } = fields
      const recaptchaPage = isValidateIdentity ? 'validateSuscriptionPage' : 'suscriptionPage'
      const recaptchaToken: string = await executeRecaptcha(recaptchaPage)

      const result: IFetchedfindInOb2Sib = await validateInSIB(
        {
          apellido: lastName,
          documento: documentType === documentCuilType ? document : documentForeign,
          nacionalidad: nacionality,
          nombre: name,
          pais: areaCode,
          tipoDocumento: documentType === documentCuilType ? 'Documento' : 'PAS',
        },
        recaptchaToken,
      )

      setToken(result.data.token, result.data.tokenType)
      return result.data?.existeSib || result.data?.existeOb2
    } catch (_) {
      return false
    }
  }

  const getCodPais = () => countries.find((country: ICountries) => country.nombre === fields.nacionality)?.codDN

  const isSendEmailError = sendEmailFailErr => isSendlError(sendEmailFailErr) || isEmailSentError(sendEmailFailErr)

  const handleSubmit = async () => {
    setSubscriberData(fields)
    navigateTo()
  }

  const handleSubmitRecoveryPassword = async () => {
    const { document, documentForeign, documentType, nacionality } = fields
    const numberDocument = documentType === documentCuilType ? document : documentForeign
    const typeDocument = documentType === documentCuilType || documentType === documentForeignType ? 'Documento' : 'PAS'
    const email = 'data@email'

    setSubscriberData({ email, numberDocument, tipoMensaje: 'BLANQUEO_CREDENCIALES', codigoPais: getCodPais(), nacionality, documentType })
    const recaptchaToken: string = await executeRecaptcha('recoveryPassword')
    const response = await sendEmailRecoveryPassword(typeDocument, numberDocument, recaptchaToken, nacionality)
    if (isSuccessStatus(response.status)) {
      const obfuscatedEmail = response.data?.obfuscatedEmail ?? 'data@email'
      setIsLoading(false)
      navigate('/suscripcion/correo', { state: { pageBefore: 'recovery', userEmailFull: obfuscatedEmail } })
    } else if (response.status === STATUS_409) {
      const sendEmailFail: IReturnSendEmailRecoveryPasswordError = response.data
      const sendEmailFailErr: returnSendEmailRecoveryPasswordErrorType = sendEmailFail.errors.shift().errorMessage
      if (isSendEmailError(sendEmailFailErr)) {
        navigate('/suscripcion/error-correo', { state: { pageBefore: 'recoveryUser409', messageType: sendEmailFailErr } })
      } else if (sendEmailFailErr === returnSendEmailRecoveryPasswordErrorType.errorNotExist) {
        if (fields.documentType === documentCuilType) {
          setErrors({
            ...errors,
            document: {
              message: 'El CUIL no esta registrado en Interbanking',
              isInvalid: true,
            },
          })
        } else {
          setErrors({
            ...errors,
            documentForeign: {
              message: 'El documento no esta registrado en Interbanking',
              isInvalid: true,
            },
          })
        }
        setIsLoading(false)
      } else {
        navigate('/suscripcion/error-correo', { state: { pageBefore: 'recoveryUser500' } })
      }
    } else {
      navigate('/suscripcion/error-correo', { state: { pageBefore: 'recoveryUser500' } })
    }
  }

  const validateCollaborator = async () => {
    try {
      setLoadingValidationCollaborator(true)
      const document = fields.nacionality === COUNTRY_ARGENTINA ? fields.document : fields.documentForeign
      const tipoDocumento = fields.documentType === documentCuilType || fields.documentType === documentForeignType ? 'Documento' : 'PAS'
      const codNationality = getCodPais()
      const recaptchaToken: string = await executeRecaptcha('validate_administrator')
      const response = await postValidateAdministrator(
        {
          collaboratorId,
          nationality: codNationality,
          document,
          tipoDocumento,
        },
        {
          headers: { 'x-recaptcha-token': recaptchaToken },
        },
      )
      const validado = response.data?.data?.validado;
      return validado
    } finally {
      setLoadingValidationCollaborator(false)
    }
  }

  const handleSubsriptionSubmit = async e => {
    if (e) {
      e.preventDefault()
    }
    syncInputsWithState()
    await new Promise(res => setTimeout(res, 50))

    const isValidForm = validateAllFields()
    if (!isValidForm) return
    sendDataLayer({
      event: 'completed_onboarding_step',
      onboarding_step: 'Ingreso datos personales',
    })
    setIsLoading(true)
    if (shouldValidateCollaborator) {
      const document = fields.nacionality === COUNTRY_ARGENTINA ? 'document' : 'documentForeign'
      const event = {
        target: {
          name: document,
          value: '',
        },
      }
      const isValid = await validateCollaborator()

      if (!isValid) {
        setIsLoading(false)
        setErrorCount(() => errorCount + 1)
        if (errorCount === 2) {
          setErrorCount(0)
          navigate('/error-reintentar')
        }
        return handleFieldError(event, {
          message: 'Los datos ingresados no coinciden con los registrados por el suscriptor',
          isInvalid: true,
        })
      }
      setIsLoading(false)
      return handleSubmit()
    }

    if (isRecoveryUser) {
      return handleSubmitRecoveryPassword()
    }
    const isSubscribed = await handleSubscribed()
    if (isSubscribed) {
      setIsLoading(false)
      return onOpen()
    }

    const numberDocument = fields.documentType === documentCuilType ? fields.document : fields.documentForeign
    const recaptchaToken: string = await executeRecaptcha('sendSubscriptorEmail')
    const { status } = await sendValidationEmail(fields.email, numberDocument, fields, recaptchaToken, 'REGISTRO_SUSCRIPTOR')

    if (!isSuccessStatus(status)) {
      navigate('/suscripcion/error-correo', { state: { pageBefore: 'subscriptorFlow' } })
    }
    return handleSubmit()
  }

  const handleDocumentForeignChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleDocumentForeignChangeData(event, handleFieldChange)
    },
    [handleFieldChange],
  )

  const handleClaveValidation = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      handleClaveValidationData(event, handleFieldError)
    },
    [handleFieldChange],
  )

  const handleReset = useCallback(async (event: React.ChangeEvent<HTMLInputElement>) => {
    const el = event.target.name
    const newErros = { ...errors }
    setErrors({
      ...newErros,
      [el]: {
        isInvalid: false,
      },
    })
  }, [])

  const handleFieldToggle = useCallback(async () => {
    setShowField(!showField)
    setShowFieldIcon(!showFieldIcon)
  }, [])

  const validateNumber = event => {
    if (event.target.name === 'areaCodePhone') {
      if (maxCharacterPhone > number14) {
        handleFieldError(event, { message: 'El formato del teléfono no es válido', isInvalid: true })
      } else {
        setErrors(prevState => ({
          ...prevState,
          phone: { message: '', isInvalid: false },
          areaCodePhone: { message: '', isInvalid: false },
          codArea: { message: '', isInvalid: false },
        }))
      }
    }
    if (event.target.name === 'phone' || event.target.name === 'codArea') {
      if (maxCharacterPhone > number14 || fields.codArea.length < 2) {
        handleFieldError(event, { message: 'El formato del teléfono no es válido', isInvalid: true })
      } else {
        setErrors(prevState => ({
          ...prevState,
          phone: { message: '', isInvalid: false },
          areaCodePhone: { message: '', isInvalid: false },
          codArea: { message: '', isInvalid: false },
        }))
      }
    }
  }

  const handleFieldValidation = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      handleFieldValidationData(event, handleFieldError, validateNumber)
    },
    [handleFieldError, validateNumber],
  )

  const handleNacionalityChange = useCallback(async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const nationalitySelected = event.target.value
    setFields(prevState => ({
      ...prevState,
      nacionality: nationalitySelected,
      documentType: nationalitySelected === COUNTRY_ARGENTINA ? documentCuilType : documentForeignType,
      document: '',
      documentForeign: '',
      areaCode: countries.find((country: ICountries) => country.nombre === nationalitySelected)?.codDN,
      areaCodePhone: countries.find((country: ICountries) => country.nombre === nationalitySelected)?.codDN,
    }))
    setErrors(prevState => ({
      ...prevState,
      document: { message: '', isInvalid: false },
      documentForeign: { message: '', isInvalid: false },
    }))
  }, [])

  useEffect(() => {
    if (!isRecoveryUser && !isNewAccount) {
      sendDataLayer({
        event: 'completed_onboarding_step',
        onboarding_step: 'Comienzo de onboarding',
      })
    }
  }, [])

const validateAllFields = (): boolean => {
  const newErrors = { ...errors }
  let hasError = false

  const isEmailValid = (email: string): boolean => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return regex.test(email)
  }

  if (isValidateIdentity) {
    if (fields.nacionality === COUNTRY_ARGENTINA) {
      if (!fields.document || fields.document.length !== cuilDigitsLength) {
        newErrors.document = {
          message: 'El CUIL debe tener 11 dígitos',
          isInvalid: true,
        }
        hasError = true
      }
    } else {
      if (!fields.documentForeign) {
        newErrors.documentForeign = {
          message: 'El documento es requerido',
          isInvalid: true,
        }
        hasError = true
      }
    }

    if (!fields.clave || fields.clave.length < 6) {
      newErrors.clave = {
        message: 'La clave es requerida (6 caracteres)',
        isInvalid: true,
      }
      hasError = true
    }
  }

  else if (isRecoveryUser && !shouldValidateCollaborator) {
    // Recuperación de usuario (sin flujo de colaborador)
    if (fields.nacionality === COUNTRY_ARGENTINA) {
      if (!fields.document || fields.document.length !== cuilDigitsLength) {
        newErrors.document = {
          message: 'El CUIL debe tener 11 dígitos',
          isInvalid: true,
        }
        hasError = true
      }
    } else {
      if (!fields.documentForeign) {
        newErrors.documentForeign = {
          message: 'El documento es requerido',
          isInvalid: true,
        }
        hasError = true
      }
    }
  }

  else if ((isNewAccount || shouldValidateCollaborator) && !isRecoveryUser) {
    // Registro de nuevo usuario o validación de colaborador (pero no si es flujo de recovery)
    if (!fields?.name?.trim()) {
      newErrors.name = { message: 'El nombre es requerido', isInvalid: true }
      hasError = true
    }

    if (!fields?.lastName?.trim()) {
      newErrors.lastName = {
        message: 'El apellido es requerido',
        isInvalid: true,
      }
      hasError = true
    }

    if (!fields?.email?.trim()) {
      newErrors.email = { message: 'El email es requerido', isInvalid: true }
      hasError = true
    } else if (!isEmailValid(fields.email)) {
      newErrors.email = {
        message: 'El formato del email es inválido',
        isInvalid: true,
      }
      hasError = true
    }

    if (fields.nacionality === COUNTRY_ARGENTINA) {
      if (!fields.document || fields.document.length !== cuilDigitsLength) {
        newErrors.document = {
          message: 'El CUIL debe tener 11 dígitos',
          isInvalid: true,
        }
        hasError = true
      }
    } else {
      if (!fields.documentForeign) {
        newErrors.documentForeign = {
          message: 'El documento es requerido',
          isInvalid: true,
        }
        hasError = true
      }
    }

    if (!fields.codArea || !fields.phone || !fields.areaCodePhone) {
      newErrors.phone = {
        message: 'El teléfono es requerido',
        isInvalid: true,
      }
      hasError = true
    }
  }

  if (hasError) {
    setErrors(prev => ({ ...prev, ...newErrors }))
  }

  return !hasError
}


  const syncInputsWithState = () => {
    const updatedValues = { ...fields }

    let visibleFields: string[] = []

    if (isValidateIdentity) {
      visibleFields = ['document', 'documentForeign', 'clave']
    } else if (isRecoveryUser) {
      visibleFields = ['document', 'documentForeign']
    } else if (isNewAccount || shouldValidateCollaborator) {
      visibleFields = ['name', 'lastName', 'email', 'phone', 'codArea', 'areaCodePhone', 'document', 'documentForeign']
    }

    visibleFields.forEach(field => {
      const inputElement = document.querySelector(`input[name="${field}"]`) as HTMLInputElement
      if (inputElement && inputElement.value !== fields[field]) {
        updatedValues[field] = inputElement.value
      }
    })

    setFields(updatedValues)
  }

  return (
    <>
      {loadingValidationCollaborator ? (
        <LoadingScreen />
      ) : (
        <Box>
          <Box my='40px'>
            <Center>
              <Heading className='title' textStyle='h3'>
                {title}
              </Heading>
            </Center>
            <Center>
              <Text className='sub-title' textStyle='titleLg'>
                {subtitle}
              </Text>
            </Center>
          </Box>
          <Box w='30%' m='0 auto'>
            <Box>
              <form className='Form' onSubmit={e => handleSubsriptionSubmit(e)} noValidate>
                <VStack spacing='12px'>
                  <FormControl>
                    <FormHelperText className='form-helper-text' textStyle='bodySm'>
                      País emisor del documento
                    </FormHelperText>
                    <Select
                      value={fields.nacionality}
                      name='nacionality'
                      data-testid='nacionality-input'
                      className='form-input'
                      bg='white'
                      onChange={handleNacionalityChange}
                    >
                      {countries.map(({ nombre }) => (
                        <option value={nombre} key={nombre}>
                          {nombre}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  {fields.nacionality === COUNTRY_ARGENTINA ? (
                    <FormInput
                      displayText='CUIL'
                      value={fields.document}
                      onChange={handleNumberFieldChange}
                      required
                      name='document'
                      placeholder='Ingresá tu CUIL sin guiones'
                      testId='cuil-input'
                      onBlur={handleCuilValidation}
                      onFocus={handleResetValidation}
                      as={InputMask}
                      mask='99-99999999-9'
                      error={errors.document ? errors.document.isInvalid : false}
                      errorMessage={errors.document ? errors.document.message : ''}
                    />
                  ) : (
                    <FormControl isInvalid={errors.documentForeign ? errors.documentForeign.isInvalid : false}>
                      <FormHelperText className='form-helper-text'>{documentDisplayName}</FormHelperText>
                      <Box>
                        <InputGroup>
                          <InputLeftAddon className='form-input' bg='white'>
                            <Select onChange={handleDocumentDisplayName} data-testid='document-input' variant='primary-outline' bg='white'>
                              {documentTypes.map(({ type }) => (
                                <option value={type} key={type}>
                                  {truncateString(type)}
                                </option>
                              ))}
                            </Select>
                          </InputLeftAddon>
                          <Input
                            value={fields.documentForeign}
                            name='documentForeign'
                            onChange={handleDocumentForeignChange}
                            onBlur={handleFieldValidation}
                            onFocus={handleResetValidation}
                            className='form-input'
                            required
                            bg='white'
                            type='text'
                            maxLength={15}
                          />
                        </InputGroup>
                        {errors.documentForeign && <FormErrorMessage>{errors.documentForeign.message}</FormErrorMessage>}
                      </Box>
                    </FormControl>
                  )}
                  {isValidateIdentity && (
                    <FormControl isInvalid={errors.input ? errors.input.isInvalid : false}>
                      <InputGroup>
                        <FormInput
                          displayText='Clave'
                          value={fields.clave}
                          onChange={handleDocumentForeignChange}
                          required
                          onFocus={handleReset}
                          maxLength={6}
                          name='clave'
                          type={showField ? 'text' : 'password'}
                          placeholder='Recibiste esta clave en tu Email '
                          testId='clave-input'
                          onBlur={handleClaveValidation}
                          error={errors.clave ? errors.clave.isInvalid : false}
                          errorMessage={errors.clave ? errors.clave.message : ''}
                        />
                        {!errors.clave?.isInvalid && (
                          <InputRightElement
                            className='form-input-field right-icon'
                            top='inherit'
                            bottom='0'
                            width='4.5rem'
                            onClick={handleFieldToggle}
                          >
                            {showFieldIcon ? (
                              <Image alt='Show input image' color='neutral.110' src={EyeSVG} />
                            ) : (
                              <Image alt='Hide input image' color='neutral.110' src={EyeOffSVG} />
                            )}
                          </InputRightElement>
                        )}
                      </InputGroup>
                    </FormControl>
                  )}
                  {!isRecoveryUser && !isValidateIdentity && (
                    <FormInput
                      displayText='Nombres'
                      value={fields.name}
                      onChange={handleTextFieldsChange}
                      onBlur={handleFieldValidation}
                      required
                      error={errors.name ? errors.name.isInvalid : false}
                      errorMessage={errors.name ? errors.name.message : ''}
                      testId='name-input'
                      maxLength={30}
                      name='name'
                      placeholder='Nombres'
                    />
                  )}
                  {!isRecoveryUser && !isValidateIdentity && (
                    <FormInput
                      displayText='Apellidos'
                      value={fields.lastName}
                      onChange={handleTextFieldsChange}
                      required
                      onBlur={handleFieldValidation}
                      error={errors.lastName ? errors.lastName.isInvalid : false}
                      errorMessage={errors.lastName ? errors.lastName.message : ''}
                      testId='lastName-input'
                      maxLength={25}
                      name='lastName'
                      placeholder='Apellidos'
                    />
                  )}
                  {!isRecoveryUser && !isValidateIdentity && (
                    <FormInput
                      displayText='Email'
                      value={fields.email}
                      onChange={handleEmailChange}
                      onBlur={handleEmailValidation}
                      required
                      name='email'
                      placeholder='Email'
                      testId='email-input'
                      maxLength={80}
                      error={errors.email ? errors.email.isInvalid : false}
                      errorMessage={errors.email ? errors.email.message : ''}
                    />
                  )}
                  {!isRecoveryUser && !isValidateIdentity && (
                    <PhoneNumber
                      values={{
                        countryPhoneCode: fields.areaCodePhone,
                        codArea: fields.codArea,
                        phone: fields.phone,
                        selectedCountry: fields.nacionality,
                      }}
                      handleNumberFieldChange={handleNumberFieldChange}
                      handleFieldValidation={handleFieldValidation}
                      handleFieldChange={handleFieldChange}
                      handleResetValidation={handleResetValidation}
                      error={errors.phone?.isInvalid || errors.codArea?.isInvalid || errors.areaCodePhone?.isInvalid || false}
                      errorMessage={errors.phone?.message || errors.codArea?.message || errors.areaCodePhone?.message || showtextifArg}
                      maxLengthNumber={maxLengthNumber}
                      maxLengthcodArea={maxLengthcodArea}
                    />
                  )}
                </VStack>
                <Center w='100%'>
                  <Button
                    disabled={isLoading}
                    type='submit'
                    data-testid='submit-button'
                    className='submit-button'
                    mt='14'
                    mb='1'
                    isLoading={!isRecoveryUser && isLoading}
                    w='180px'
                  >
                    Continuar
                  </Button>
                </Center>
              </form>
            </Box>
          </Box>
        </Box>
      )}
      <Center w='100%' mt={4}>
        {!isValidateIdentity &&
          (!isRecoveryUser ? (
            <>
              <Text className='link' textStyle='labelLg'>
                ¿Tenés una cuenta y querés agregar empresas?
              </Text>
              <Button variant='primary-text' onClick={signinRedirect}>
                Iniciar sesión
              </Button>
            </>
          ) : (
            !isNewAccount &&
            !isRecoveryUser && (
              <Link className='link--underline' href='/onboarding2-ui/suscripcion/datos'>
                Cancelar
              </Link>
            )
          ))}
      </Center>
      {isRecoveryUser && isLoading && (
        <Flex h='100vh' w='100vw' position='absolute' left='32vw' top='32vh'>
          <Spinner data-testid='spinner' w='48px' h='48px' emptyColor='primary.500' color='primary.60' thickness='4px' />
        </Flex>
      )}
      <IBalert
        type='error'
        isOpen={isOpen}
        onClose={onClose}
        title='Ya existe una cuenta con estos datos'
        text='Ingresá a Interbanking para agregar más empresas o revisar suscripciones en curso.'
        textButton='Iniciar sesión'
        onButtonClick={signinRedirect}
        variant='linkError'
        buttonClose
      />
    </>
  )
}

export default RegisterSuscription
